import './App.css';
import About from './components/About/About';
import CircularMenu from './components/CircularMenu/CircularMenu';
import Footer from './components/Footer/Footer';
import FooterForm from './components/FooterForm/FooterForm';
import Message from './components/Message/Message';
import Nav from './components/Nav/Nav';
import News from './components/News/News';
import Service from './components/Service/Service';
import Slider from './components/Slider/Slider';
import Vision from './components/Vision/Vision';

function App() {
  return (
    <>
      <Nav/>
      <CircularMenu/>
      <Slider/>
      <Service/>
      <Message/>
      <Vision/>
      <News/>
      <About/>
      <FooterForm/>
      <Footer/>
    </>
  );
}

export default App;
